export default {
  C_ABAP_OS_CPU: {
    fields: [{ code: 'usedRate', text: 'CPU Used', type: 'PERCENT', unit: 1 }],
  },
  C_ABAP_OS_MEM: {
    fields: [
      { code: 'memUsedRate', text: 'Memory Used', type: 'PERCENT', unit: 1 },
      { code: 'swapUsedRate', text: 'Swap Used', type: 'PERCENT', unit: 1 },
    ],
  },
  C_ABAP_OS_DISK: {
    fields: [{ code: 'kbSec', text: 'Transfered', type: 'KILO_BYTE', unit: 1 }],
  },
  C_ABAP_OS_NTWK: {
    fields: [
      { code: 'packets', text: 'Packets', type: 'DIGIT', unit: 1 },
      { code: 'inPackets', text: 'Packets In', type: 'DIGIT', unit: 1 },
      { code: 'outPackets', text: 'Packets Out', type: 'DIGIT', unit: 1 },
      { code: 'inErrors', text: 'Errors In', type: 'DIGIT', unit: 1 },
      { code: 'outErrors', text: 'Errors Out', type: 'DIGIT', unit: 1 },
      { code: 'collisions', text: 'Collisions', type: 'DIGIT', unit: 1 },
    ],
  },
  // C_ABAP_OS_FILE_SSTM을 C_ABAP_OS_FSYS로 변경.2022.07.18.KWShin.
  C_ABAP_OS_FSYS: {
    fields: [{ code: 'usedRate', text: 'Used rate', type: 'PERCENT', unit: 1 }],
  },
  // BEGIN::Added.by.2022.07.20.KWShin.
  C_PCAP_OS_CPU: {
    fields: [{ code: 'usedRate', text: 'CPU Used', type: 'PERCENT', unit: 1 }],
  },
  C_PCAP_OS_MEM: {
    fields: [
      { code: 'memUsedRate', text: 'Memory Used', type: 'PERCENT', unit: 1 },
      { code: 'swapUsedRate', text: 'Swap Used', type: 'PERCENT', unit: 1 },
    ],
  },
  C_PCAP_OS_DISK: {
    fields: [{ code: 'kbSec', text: 'Transfered', type: 'KILO_BYTE', unit: 1 }],
  },
  C_PCAP_OS_NTWK: {
    fields: [
      { code: 'packets', text: 'Packets', type: 'DIGIT', unit: 1 },
      { code: 'inPackets', text: 'Packets In', type: 'DIGIT', unit: 1 },
      { code: 'outPackets', text: 'Packets Out', type: 'DIGIT', unit: 1 },
      { code: 'inKb', text: 'In', type: 'KILO_BYTE', unit: 1 },
      { code: 'outKb', text: 'Out', type: 'KILO_BYTE', unit: 1 },
      { code: 'inErrors', text: 'Errors In', type: 'DIGIT', unit: 1 },
      { code: 'outErrors', text: 'Errors Out', type: 'DIGIT', unit: 1 },
      { code: 'collisions', text: 'Collisions', type: 'DIGIT', unit: 1 },
    ],
  },
  C_PCAP_OS_FSYS: {
    fields: [{ code: 'usedRate', text: 'Used rate', type: 'PERCENT', unit: 1 }],
  },
  // FINISH::Added.by.2022.07.20.KWShin.
  C_ABAP_RESP_TIME: {
    fields: [{ code: 'avgRespti', text: 'Response Time', type: 'MICRO_SECOND', unit: 0.000001 }],
  },
  C_ABAP_LOGON_USER: {
    fields: [
      { code: 'idCount', text: 'Logon ID', type: 'DIGIT', unit: 1 },
      { code: 'sessionCount', text: 'Logon Session', type: 'DIGIT', unit: 1 },
    ],
  },
  C_ABAP_LOGON_DUP: {
    fields: [{ code: 'count', text: 'Count', type: 'DIGIT', unit: 1 }],
  },
  C_ABAP_QUEUE: {
    fields: [
      { code: 'nowCount', text: 'Count', type: 'DIGIT', unit: 1 },
      { code: 'reads', text: 'Reads', type: 'DIGIT', unit: 1 },
      { code: 'writes', text: 'Writes', type: 'DIGIT', unit: 1 },
    ],
  },
  C_ABAP_MEMORY_AREA_NAME: {
    fields: [{ code: 'usedRate', text: 'Used Ratio', type: 'PERCENT', unit: 1 }],
  },
  C_ABAP_MEMORY: {
    fields: [{ code: 'usedRate', text: 'Used Rate', type: 'PERCENT', unit: 1 }],
    // BEGIN::Added.by.SHJ.2026.04.22.
    // Modified.by.KWShin.2026.10.28. 순서를 owlens-model 의 SapMemory enum 순서로 바꾼다(막대 차트 X축도 이 순서를 따른다).
    // memoryTypes: [
    //   { code: 'ALL', text: 'ALL' },
    //   { code: 'EXTENDED MEMORY', text: 'EXTENDED MEMORY' },
    //   { code: 'HEAP MEMORY', text: 'HEAP MEMORY' },
    //   { code: 'IDs', text: 'IDs' },
    //   { code: 'PAGE AREA', text: 'PAGE AREA' },
    //   { code: 'ROLL AREA', text: 'ROLL AREA' },
    //   { code: 'STATEMENT', text: 'STATEMENT' },
    // ],
    memoryTypes: [
      { code: 'ALL', text: 'ALL' },
      { code: 'EXTENDED MEMORY', text: 'EXTENDED MEMORY' },
      { code: 'ROLL AREA', text: 'ROLL AREA' },
      { code: 'PAGE AREA', text: 'PAGE AREA' },
      { code: 'HEAP MEMORY', text: 'HEAP MEMORY' },
      { code: 'STATEMENT', text: 'STATEMENT' },
      { code: 'IDs', text: 'IDs' },
    ],
    // FINISH::Added.by.SHJ.2026.04.22.
  },
  C_ABAP_BUFF: {
    fields: [{ code: 'hitratio', text: 'Hit Ratio', type: 'PERCENT', unit: 1 }],
    // BEGIN::Added.by.SHJ.2026.04.22.
    // Commented.by.KWShin.2026.10.28. 순서는 owlens-model 의 SapBuffer enum 순서와 같다(막대 차트 X축도 이 순서를 따른다).
    bufferTypes: [
      { code: 'ALL', text: 'ALL' },
      { code: 'TTAB', text: 'TTAB (Table Definition)' },
      { code: 'FTAB', text: 'FTAB (Field Definition)' },
      { code: 'SNTAB', text: 'SNTAB (Short NTAB)' },
      { code: 'IRBD', text: 'IRBD (Initial Record)' },
      { code: 'TABL', text: 'TABL (Generic Key)' },
      { code: 'TABLP', text: 'TABLP (Single Record)' },
      { code: 'PXA', text: 'PXA (Program)' },
      { code: 'CUA', text: 'CUA (Window Menu & Button)' },
      { code: 'PRES', text: 'PRES (Screen)' },
      { code: 'CALE', text: 'CALE (Calendar)' },
      { code: 'EIBUF', text: 'EIBUF (Export/Import)' },
      { code: 'OTR', text: 'OTR' },
      { code: 'ESM', text: 'ESM (Export/Import SHM)' },
    ],
    // FINISH::Added.by.SHJ.2026.04.22.
  },
  C_ABAP_THROUGHPUT: {
    fields: [{ code: 'totStep', text: 'Total Step', type: 'DIGIT', unit: 1 }],
  },
  C_ABAP_WORK_PROC: {
    fields: [
      { code: 'runningRate', text: 'Running', type: 'PERCENT', unit: 1 },
      { code: 'waitingRate', text: 'Waiting', type: 'PERCENT', unit: 1 },
      { code: 'onHoldRate', text: 'On Hold', type: 'PERCENT', unit: 1 },
    ],
  },
  C_ABAP_ENQ_LOCK: {
    fields: [{ code: 'count', text: 'Count', type: 'DIGIT', unit: 1 }],
  },
  // BEGIN::Added.by.2024.09.15.KWShin.
  C_ABAP_DB_THROUGHPUT: {
    fields: [{ code: 'totDbstep', text: 'Count', type: 'DIGIT', unit: 1 }],
  },
  C_ABAP_DB_RESP_TIME: {
    fields: [{ code: 'avgDbtime', text: 'Response Time (ms)', type: 'MILLI_SECOND', unit: 0.001 }],
  },
  C_DB_HANA_SPACE: {
    fields: [{ code: 'usedRate', text: 'Used Rate', type: 'PERCENT', unit: 1 }],
  },
  C_DB_ORCL_SPACE: {
    fields: [{ code: 'usedRate', text: 'Used Rate', type: 'PERCENT', unit: 1 }],
  },
  C_DB_HANA_MEM: {
    fields: [{ code: 'usedRate', text: 'Used rate', type: 'PERCENT', unit: 1 }],
  },
  C_DB_ORCL_TABL: {
    fields: [{ code: 'usedRate', text: 'Used rate', type: 'PERCENT', unit: 1 }],
  },
  // FINISH::Added.by.2024.09.15.KWShin.
  C_DB_EXCL_LOCK: {
    fields: [{ code: 'count', text: 'Count', type: 'DIGIT', unit: 1 }],
  },
  C_DB_HANA_LOCK: {
    fields: [{ code: 'count', text: 'Count', type: 'DIGIT', unit: 1 }],
  },
  C_ABAP_TRFC_QIN: {
    fields: [{ code: 'count', text: 'Count', type: 'DIGIT', unit: 1 }],
  },
  C_ABAP_TRFC_QOUT: {
    fields: [{ code: 'count', text: 'Count', type: 'DIGIT', unit: 1 }],
  },
  C_ABAP_UPD_REC: {
    fields: [{ code: 'count', text: 'Count', type: 'DIGIT', unit: 1 }],
  },
  C_ABAP_DUMP: {
    fields: [{ code: 'count', text: 'Count', type: 'DIGIT', unit: 1 }],
  },
  // BEGIN::Added.by.2023.06.21.KWShin.
  C_ABAP_APP_LOG: {
    fields: [{ code: 'count', text: 'Count', type: 'DIGIT', unit: 1 }],
  },
  C_ABAP_SYS_LOG: {
    fields: [{ code: 'count', text: 'Count', type: 'DIGIT', unit: 1 }],
  },
  // FINISH::Added.by.2023.06.21.KWShin.
  C_JAVA_MEM: {
    fields: [{ code: 'used', text: 'Used', type: 'BYTE', unit: 1 }],
  },
  C_JAVA_LOG: {
    fields: [
      { code: 'info', text: 'Info', type: 'DIGIT', unit: 1 },
      { code: 'warn', text: 'Warn', type: 'DIGIT', unit: 1 },
      { code: 'debug', text: 'Debug', type: 'DIGIT', unit: 1 },
      { code: 'error', text: 'Error', type: 'DIGIT', unit: 1 },
      { code: 'fatal', text: 'Fatal', type: 'DIGIT', unit: 1 },
    ],
  },
  C_JAVA_MSG_CMCN: {
    fields: [
      { code: 'msBytesSend', text: 'Send', type: 'BYTE', unit: 1 },
      { code: 'msBytesReceived', text: 'Received', type: 'BYTE', unit: 1 },
    ],
  },
  C_JAVA_ENQ_LOCK: {
    fields: [{ code: 'count', text: 'count', type: 'DIGIT', unit: 1 }],
  },
  C_JAVA_REQ_QUEUE: {
    fields: [
      { code: 'now', text: 'Now Count', type: 'DIGIT', unit: 1 },
      { code: 'reads', text: 'Reads', type: 'DIGIT', unit: 1 },
      { code: 'writes', text: 'Writes', type: 'DIGIT', unit: 1 },
    ],
  },
  C_JAVA_RESP_TIME: {
    fields: [{ code: 'avgRespti', text: 'Response Time', type: 'DIGIT', unit: 1 }],
  },
  // BEGIN::Removed.by.KWShin.2025.11.28.
  // C_JAVA_OS_CPU_WS: {
  //   fields: [{ code: 'usedRate', text: 'Used rate', type: 'PERCENT', unit: 1 }],
  // },
  // FINISH::Removed.by.KWShin.2025.11.28.
  C_JAVA_OS_CPU: {
    fields: [{ code: 'usedRate', text: 'Used rate', type: 'PERCENT', unit: 1 }],
  },
  // BEGIN::Removed.by.KWShin.2025.11.28.
  // C_JAVA_OS_DISK_WS: {
  //   fields: [{ code: 'tps', text: 'Transfered', type: 'KILO_BYTE', unit: 1 }],
  // },
  // FINISH::Removed.by.KWShin.2025.11.28.
  C_JAVA_OS_DISK: {
    // fields: [{ code: 'usedRate', text: 'Used rate', type: 'PERCENT', unit: 1 }],
    fields: [{ code: 'tps', text: 'Transfered', type: 'KILO_BYTE', unit: 1 }],
  },
  // BEGIN::Removed.by.KWShin.2025.11.28.
  // C_JAVA_OS_MEM_WS: {
  //   fields: [
  //     { code: 'memUsedRate', text: 'Memory Used', type: 'PERCENT', unit: 1 },
  //     { code: 'swapUsedRate', text: 'Swap Used', type: 'PERCENT', unit: 1 },
  //   ],
  // },
  // FINISH::Removed.by.KWShin.2025.11.28.
  C_JAVA_OS_MEM: {
    // fields: [{ code: 'usedRate', text: 'Used rate', type: 'PERCENT', unit: 1 }],
    fields: [{ code: 'memUsedRate', text: 'Used rate', type: 'PERCENT', unit: 1 }],
  },
  // BEGIN::Removed.by.KWShin.2025.11.28.
  // C_JAVA_OS_NTWK_WS: {
  //   fields: [{ code: 'rxPackets', text: 'Packets out per interval', type: 'DIGIT', unit: 1 }],
  // },
  // FINISH::Removed.by.KWShin.2025.11.28.
  // BEGIN::Removed.by.KWShin.2025.11.28.
  C_JAVA_OS_NTWK: {
    fields: [
      { code: 'rxBytes', text: 'Bytes in', type: 'KILO_BYTE', unit: 0.001 },
      { code: 'txBytes', text: 'Bytes out', type: 'KILO_BYTE', unit: 0.001 },
      { code: 'rxPackets', text: 'Packets in', type: 'DIGIT', unit: 1 },
      { code: 'txPackets', text: 'Packets out', type: 'DIGIT', unit: 1 },
      { code: 'rxErrors', text: 'Errors int', type: 'DIGIT', unit: 1 },
      { code: 'txErrors', text: 'Errors out', type: 'DIGIT', unit: 1 },
    ],
  },
  // FINISH::Removed.by.KWShin.2025.11.28.
  C_JAVA_OS_FSYS_WS: {
    fields: [{ code: 'usedRate', text: 'Used rate', type: 'PERCENT', unit: 1 }],
  },
  C_JAVA_OS_FSYS: {
    fields: [{ code: 'usedRate', text: 'Used rate', type: 'PERCENT', unit: 1 }],
  },
  C_JAVA_JDBC_CONN: {
    fields: [
      { code: 'usedRate', text: 'Used rate', type: 'PERCENT', unit: 1 },
      { code: 'usedSize', text: 'Used size', type: 'DIGIT', unit: 1 },
    ],
  },
  C_JAVA_TRXN: {
    fields: [
      { code: 'openTransCount', text: 'Open', type: 'DIGIT', unit: 1 },
      { code: 'committedCount', text: 'Committed', type: 'DIGIT', unit: 1 },
      { code: 'rolledbackCount', text: 'Rolledback', type: 'DIGIT', unit: 1 },
      { code: 'timedoutCount', text: 'Timedout', type: 'DIGIT', unit: 1 },
      { code: 'suspendedCount', text: 'Suspended', type: 'DIGIT', unit: 1 },
      { code: 'successRate', text: 'Success rate', type: 'PERCENT', unit: 1 },
    ],
  },
  C_JAVA_DB_LOCK: {
    fields: [{ code: 'count', text: 'count', type: 'DIGIT', unit: 1 }],
  },
  C_JAVA_HTTP_SESS: {
    fields: [{ code: 'count', text: 'count', type: 'DIGIT', unit: 1 }],
  },
  C_JAVA_SSTM_THRD: {
    fields: [
      { code: 'activeThreadsCount', text: 'Active Thread', type: 'DIGIT', unit: 1 },
      { code: 'currentThreadCount', text: 'Current Thread', type: 'DIGIT', unit: 1 },
      { code: 'threadPoolUsageRate', text: 'Thread Pool usage', type: 'PERCENT', unit: 1 },
    ],
  },
  C_JAVA_APPL_THRD: {
    fields: [
      { code: 'activeThreadsCount', text: 'Active Thread', type: 'DIGIT', unit: 1 },
      { code: 'currentThreadCount', text: 'Current Thread', type: 'DIGIT', unit: 1 },
      { code: 'threadPoolUsageRate', text: 'Thread Pool usage', type: 'PERCENT', unit: 1 },
    ],
  },
  C_JAVA_HTTP_PRVDR: {
    fields: [
      { code: 'requestCount', text: 'Requests', type: 'DIGIT', unit: 1 },
      { code: 'responseCount', text: 'Responses', type: 'DIGIT', unit: 1 },
      { code: 'avgResponseTime', text: 'Avg. RS Time (ms)', type: 'MILLI_SECOND', unit: 1 },
    ],
  },
  C_JAVA_JSP: {
    fields: [
      { code: 'requestCount', text: 'Requests', type: 'DIGIT', unit: 1 },
      { code: 'responseCount', text: 'Responses', type: 'DIGIT', unit: 1 },
      { code: 'avgResponseTime', text: 'Avg. RS Time (ms)', type: 'MILLI_SECOND', unit: 0.001 },
    ],
  },
  C_JAVA_P4: {
    fields: [
      { code: 'requestCount', text: 'Requests', type: 'DIGIT', unit: 1 },
      { code: 'errorRequestCount', text: 'Error Requests', type: 'DIGIT', unit: 1 },
      { code: 'exportedRemoteObjectsCount', text: 'Remote objects', type: 'DIGIT', unit: 1 },
    ],
  },
  C_JAVA_SVC_STAT: {
    fields: [
      { code: 'startedCount', text: 'Started', type: 'DIGIT', unit: 1 },
      { code: 'stoppedCount', text: 'Stopped', type: 'DIGIT', unit: 1 },
      { code: 'startedRate', text: 'Started rate', type: 'PERCENT', unit: 1 },
      { code: 'stoppedRate', text: 'Stopped rate', type: 'PERCENT', unit: 1 },
    ],
  },
};
